
import HomeCategories from '@/graphql/queries/taxonomies/HomeCategories'
import { nthChild } from 'vessel/utils'

export default {
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: HomeCategories,
      variables: { where: { kind: 'category' }, children: 8 }
    })

    this.categories = data.children
  },
  data() {
    return {
      categories: null
    }
  },
  computed: {
    hasItems() {
      return this.categories && this.categories.length
    },
    minHeight() {
      return this.$fetchState.pending && 'screen'
    },
    backgroundColor() {
      return this.hasItems && 'grey-light'
    },
    primaryItems() {
      return this.categories && this.categories.slice(0, 4)
    },
    secondaryItems() {
      return this.categories && this.categories.slice(4)
    }
  },
  methods: {
    columnBg(index, rule) {
      return nthChild((index + 1), rule)
        ? 'grey-lightest'
        : 'white'
    },
    columnClass(index) {
      return this.$vessel.apply({
        height: 'full',
        textAlign: {
          all: 'center',
          sm: 'left'
        },
        backgroundColor: {
          all: this.columnBg(index, '2n + 1'),
          xl: this.columnBg(index, ['4n', '4n + 1'])
        },
        paddingY: {
          all: 'lg',
          sm: 'xl',
          xl: '2xl'
        },
        paddingX: {
          all: 'md',
          xl: '2xl'
        },
      })
    },
    itemImage(item) {
      return {
        src: '/warning.svg',
        inline: true,
        fit: 'contain',
        width: { all: '3xl', sm: 'full' },
        ratio: { all: null, sm: 'square' },
        marginBottom: { all: 'md', sm: 0 },
        ...item.image
      }
    },
    itemLink(item) {
      const route = { name: 'categories-id', params: { id: item.slug } }
      return item.slug ? this.$pagePath(route) : this.$pagePath('/products')
    },
    itemText(item) {
      return {
        html: item.excerpt,
        fontWeight: 'light',
        textColor: 'black',
        leading: 'md'
      }
    }
  }
}
